import emptySate from "../../assets/images/empty_state.svg";

function EmptyState() {
  return <img src={emptySate} alt="empty state" />;
}

export default EmptyState